import React, { useEffect, useRef } from "react";

import "./Buttons.css";

const ScreenShared = ({ stream }) => {
    const localStreamRef = useRef();

    useEffect(() => {
        const video = localStreamRef.current;
        video.srcObject = stream;

        video.onloadedmetadata = () => {
            video.play();
        }
    }, [stream]);

    return (
        <div className="share_preview_container">
            <video muted autoPlay ref={localStreamRef} className="video_sharing_preview"></video>
        </div>
    );
};

export default ScreenShared;